export const initSubValueItem = ({index = 0, long = 1, a = '', b = '', c = '', is_sum = false, title_id = ''} = {}) => ({
    index,
    long,
    is_sum,
    title_id,
    a,
    b,
    c
  })
export const createMonthHeader = ({value = ''} = {}) => ({
  align: 'center',
  type: 'month',
  width: '15%',
  text: '',
  value,
  showDateMenu:false,
})
export const createValue = ({is_sum = false} = {}) => ({
  is_sum,
  title_id:'',
})
export const initunHcSub = () => ({
  _header:[
    {
      align: 'left',
      width: '28%',
      text: '科目类型',
      value:'title_id'
    },
    {
      align: 'center',
      type: 'month',
      width: '15%',
      text: '',
      value:'',
      showDateMenu:false,
    },
    {
      align: 'right',
      width: '20%',
      text: '总计',
      value:'sum'
    }
],
  _value:[
    createValue({ is_sum:false }),
    createValue({ is_sum:true })
  ]
})
export const initSub = () => ({
  show_delete_menus:false,
  headcount_type: null,
  sequence_name: null,
  headcount_total: null,
  // table的header
  table_data: initunHcSub()
})
export const subInitData = () => ({
    id:undefined,
    order_id: undefined,
    team_id: null,
    headcount_total: null,
    type: '',
    headcount_type: null,
    sequence_name: null,
    date: null,
    future_expense: null,
    bfiles: null,
    remark: null,
    name: null,
    items:[ // todo
      {
        budget_month: '',
        budget_amount: ''
      }
    ],
    un_hc_child_item_arr:initunHcSub(),
    hc_child_item_arr: [
      initSub()
    ]
  })
  export const decimalRule_0 = (data) => {
    if (data < 0 || (data && !/^\d*(\.[1-9]|\.\d[1-9])*$/.test(data))) {
      return '请输入有效位数为2的非负数'
    }
    return true
  }
// 校验数据的正确性
export const decimalRule = (data) => {
  if (data <= 0 || (data && !/^\d*(\.[1-9]|\.\d[1-9])*$/.test(data))) {
    return '请输入小数位不大于2的正数'
  }
  return true
}
export const integer = (data) => {
  data = data + '' 
  if (data && Number(data).toFixed(0) !== data) {
    return '请输入整数'
  }
  return true
}

// 验证数据是否为正整数
export const positiveInteger = (data) => {
  if (Number(data) <= 0 || (data && Number(data).toFixed(0) !== data + '')) {
    return '请输入正整数'
  }
  return true
}

// 必填项
export const nonNull = (type) => {
  return data => {
    if ([null, '', undefined].includes(data)) {
      return type
    }
    return true
  }
}


// 如果没有填写也可以
export const blankdecimalRule = (data) => {
  if (!['', null, undefined].includes(data) && (data && !/^-?\d*(\.[1-9]|\.\d[1-9])*$/.test(data))) {
    return '请输入有效位数为2的数字'
  }
  return true
}
